"use client";

import React from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
export default function WhyShoppersLoveUs() {
  const testimonials = [{
    author: "Local Driver",
    quote: "Fast, friendly, and honest pricing. They got me in and out for my oil change in no time."
  }, {
    author: "Jasper Resident",
    quote: "The best quick oil change in Kimball. Highly professional service every single visit."
  }, {
    author: "Regular Customer",
    quote: "Expert tire service and preventative maintenance. I trust them with all my family's vehicles."
  }];
  return <section data-section-id="221909" id="what-our-customers-are-saying" className="bg-background text-foreground py-24 overflow-hidden relative">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-primary/5 blur-[100px] rounded-lg pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 max-w-7xl relative z-10">
        {}
        <div className="flex flex-col items-center text-center mb-16 md:mb-24">
          <div className="flex gap-1.5 mb-6 text-yellow-500">
            {[...Array(5)].map((_, i) => <Star key={i} className="size-6 md:size-8 fill-current" />)}
          </div>
          <h2 className="text-5xl md:text-7xl font-default font-bold tracking-tighter text-primary mb-6 uppercase">
            4.8
            <span className="text-4xl md:text-6xl text-muted-foreground font-light tracking-normal ml-1">
              /5
            </span>
          </h2>
          <div className="max-w-md space-y-2">
            <p className="text-foreground font-default font-semibold text-lg uppercase tracking-wider">
              Based on Google Reviews
            </p>
            <p className="text-muted-foreground text-sm font-default leading-relaxed">
              Our customers value our speed, reliability, and industrial-grade precision. 
              Experience the Kimball Speedy Lube difference today.
            </p>
          </div>
        </div>

        {}
        <Carousel opts={{
        align: "start",
        loop: true
      }} className="w-full">
          <CarouselContent className="-ml-2 md:-ml-4">
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3">
                <Card className="h-full border-2 border-border shadow-md bg-card hover:border-primary transition-colors duration-200 rounded-md">
                  <CardContent className="p-6 md:p-8 flex flex-col justify-between h-full gap-8">
                    <p className="font-serif italic text-xl md:text-2xl text-foreground leading-snug">
                      "{testimonial.quote}"
                    </p>
                    <div className="flex items-center gap-4 pt-6 border-t border-border mt-auto">
                      <div className="size-10 rounded-md bg-primary/10 flex items-center justify-center text-primary font-default font-bold text-sm">
                        —
                      </div>
                      <div className="font-default font-bold text-sm text-primary tracking-widest uppercase">
                        {testimonial.author}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex items-center justify-center gap-4 mt-12 md:mt-16">
            <CarouselPrevious className="relative inset-0 translate-y-0 size-10 md:size-12 rounded-md border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all" />
            <CarouselNext className="relative inset-0 translate-y-0 size-10 md:size-12 rounded-md border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all" />
          </div>
        </Carousel>
      </div>
    </section>;
}